<template>
  <el-dialog
    :visible.sync="setDialogVisiable"
    class="set-option-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="closeForm"
    title="插选项"
    width="560px"
  >
    <div class="main">
      <div class="tag-item">
        <span class="label" style="margin-right: 12px;">选项数</span>
        <el-input-number
          class="height32 width90"
          v-model="tagForm.num"
          :controls="false"
          :min="1"
        ></el-input-number>
      </div>
      <div class="tag-item">
        <span class="label" style="margin-right: 12px;">题号</span>
        <el-input-number
          class="height32 width90"
          v-model="tagForm.start"
          :controls="false"
          :min="1"
        ></el-input-number>
        <span class="line">
          -
        </span>
        <el-input-number
          class="height32 width90"
          v-model="tagForm.end"
          :controls="false"
          :min="1"
        ></el-input-number>
      </div>
    </div>
    <div class="btn-list">
      <div
        class="close-btn"
        @click="closeForm"
      >
        关闭
      </div>
      <div
        class="submit-btn"
        @click="submitForm"
      >
        提交
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { isEmpty } from '@/utils/tools'

export default {
  name: "set-option-dialog",
  data() {
    return {
      loading: false,
      tagForm: {
        num: "",
        start: "",
        end: "",
      }
    };
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      },
    }
  },
  computed: {
    setDialogVisiable: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    async setDialogVisiable(newValue, oldValue) {
      if (newValue) {
        this.tagForm = {
          num: "",
          start: "",
          end: "",
        }
      }
    }
  },
  methods: {
    closeForm() {
      this.setDialogVisiable = false;
    },
    submitForm() {
      if (this.loading) {
        return
      }
      this.loading = true
      if (!this.tagForm.num) {
        this.$message.warning("请输入选项数");
        this.loading = false
        return
      }
      if (!this.tagForm.start || !this.tagForm.end) {
        this.$message.warning("请输入题号");
        this.loading = false
        return
      }
      if (this.tagForm.start > this.tagForm.end) {
        this.$message.warning("开始题号大于结束题号");
        this.loading = false
        return
      }
      this.$emit('setOption', {
        ...this.tagForm
      });
      this.setDialogVisiable = false;
      this.loading = false
    }
  },
};
</script>
<style lang='scss'>
.set-option-dialog {
  .el-dialog {
    border-radius: 4px;
  }

  .el-dialog__header {
    font-weight: bold;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    padding: 16px;
    border: 1px solid #e5e6eb;
    border-radius: 4px 4px 0 0;

    .title {
      font-size: 16px;
      font-style: normal;
      color: #1d2129;
      line-height: 24px;

      em {
        font-weight: normal;
        font-style: normal;
        font-size: 14px;
        line-height: 24px;
        color: #4e5969;
      }
    }
  }
  .el-dialog__body {
    padding: 0 16px 16px 16px;
    border-radius: 0 0 4px 4px;

    .main {
      padding-top: 32px;

      .tag-item {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 24px;
        margin-left: 116px;

        span.label {
          font-size: 14px;
          color: #1D2129;
          text-align: right;
          line-height: 22px;
        }

        span.line {
          display: block;
          width: 20px;
          text-align: center;
        }
      }
    }

    .btn-list {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 32px auto 0 auto;
    }

    .close-btn {
      width: 88px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      color: #0fa784;
      background: #fff;
      border: 1px solid #0fa784;
      border-radius: 2px;
      cursor: pointer;
      box-sizing: border-box;
      margin-right: 16px;
    }

    .submit-btn {
      width: 88px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background: #0fa784;
      border-radius: 2px;
      cursor: pointer;
      box-sizing: border-box;
    }
  }

  .height32 {
    height: 32px;
    line-height: 32px;

    .el-input__inner {
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
    }

    .el-input__icon {
      line-height: 32px;
    }
  }

  .width90 {
    width: 90px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/htmlSplit/components/setOptionNum.vue